// Augmentation dati menu: immagini per categoria + allergeni default per categoria + override per item specifico.
// Questo file estende MENU_CATEGORIES senza dover riscrivere l'intero menu.

// Immagini Unsplash per categoria — rotate su .n (item number)
export const CATEGORY_IMAGES = {
  ramen: [
    "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1591814468924-caf88d1232e1?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1618889482923-38250401a84e?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1557872943-16a5ac26437e?w=800&q=80&auto=format&fit=crop",
  ],
  ravioli: [
    "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1541696490-8744a5dc0228?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1626804475297-41608ea09aeb?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1563245372-f21724e3856d?w=800&q=80&auto=format&fit=crop",
  ],
  baozi: [
    "https://images.unsplash.com/photo-1563245372-f21724e3856d?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1626804475297-41608ea09aeb?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1541696490-8744a5dc0228?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=800&q=80&auto=format&fit=crop",
  ],
  riso: [
    "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1596797038530-2c107229654b?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1567982047351-76b6f93e38ee?w=800&q=80&auto=format&fit=crop",
  ],
  carne: [
    "https://images.unsplash.com/photo-1544025162-d76694265947?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1594221708779-94832f4320d1?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=800&q=80&auto=format&fit=crop",
  ],
  antipasti: [
    "https://images.unsplash.com/photo-1541599540903-216a46ca1dc0?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1583224944844-5b268c057b6a?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1608835291093-394b0c943a75?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1553163147-622ab57be1c7?w=800&q=80&auto=format&fit=crop",
  ],
  primi: [
    "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1552611052-33e04de081de?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1585032226651-759b368d7246?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1543826173-70651703c5a4?w=800&q=80&auto=format&fit=crop",
  ],
  spiedini: [
    "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1544025162-d76694265947?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1600891964092-4316c288032e?w=800&q=80&auto=format&fit=crop",
  ],
  bevande: [
    "https://images.unsplash.com/photo-1558857563-b371033873b5?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1541696490-8744a5dc0228?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1523371683702-1eb8ffc6d5cd?w=800&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1541599540903-216a46ca1dc0?w=800&q=80&auto=format&fit=crop",
  ],
};

// Allergeni default per categoria
export const CATEGORY_ALLERGENS = {
  ramen:     ["glutine", "soia", "uova", "sesamo"],
  ravioli:   ["glutine", "soia"],
  baozi:     ["glutine", "soia"],
  riso:      ["soia", "uova", "sesamo"],
  carne:     ["soia", "sesamo"],
  antipasti: ["soia"],
  primi:     ["glutine", "soia", "sesamo"],
  spiedini:  ["soia", "sesamo"],
  bevande:   ["latte"],
};

// Override per item specifico (aggiungi allergeni extra o sostituisci)
// key = "{categoryId}-{item.n}"
export const ITEM_ALLERGEN_OVERRIDES = {
  // Ramen
  "ramen-1": ["glutine", "soia", "uova", "sesamo", "sedano"],
  "ramen-6a": ["glutine", "soia", "uova", "sesamo", "crostacei"],
  "ramen-6b": ["glutine", "soia", "uova", "sesamo", "crostacei"],
  "ramen-5": ["glutine", "uova", "sedano"],
  // Ravioli
  "ravioli-10": ["glutine", "soia", "crostacei"],
  "ravioli-11": ["glutine", "soia", "sedano"],
  // Baozi
  "baozi-16": ["glutine", "soia", "uova", "latte"],
  // Riso
  "riso-18": ["soia", "sesamo"],
  "riso-20": ["soia", "uova", "sesamo"],
  // Carne
  "carne-25": ["glutine", "soia", "sesamo"],
  "carne-31": ["glutine", "soia", "sesamo"],
  "carne-32": ["glutine", "soia", "sesamo"],
  "carne-33": ["glutine", "crostacei", "uova"],
  // Antipasti
  "antipasti-34": ["glutine", "uova"],
  "antipasti-37": ["glutine", "soia"],
  "antipasti-39": ["molluschi", "soia"],
  // Primi
  "primi-118": ["glutine", "soia", "crostacei", "sesamo"],
  "primi-121": ["glutine", "soia", "crostacei", "sesamo"],
  "primi-127": ["glutine", "soia", "crostacei"],
  "primi-128": [], // patatine fritte
  // Spiedini seafood
  "spiedini-50": ["molluschi"],
  "spiedini-63": ["pesce"],
  // Bevande
  "bevande-42": ["latte"],
  "bevande-45": ["latte", "fruttaguscio"],
};

// Get image URL for an item (rotates within category)
export function getItemImage(categoryId, itemN, index = 0) {
  // Override per foto REALI da Glovo (ristorante Drago Ramen)
  const key = `${categoryId}-${itemN}`;
  const REAL = {
    "ramen-1": "https://glovo.dhmedia.io/image/menus-glovo/products/6c924869a6705a2543d35656b07f23a7f39775c5b07ec5034e375c23492ae4b1?t=W3sicmVzaXplIjp7Im1vZGUiOiJmaXQiLCJ3aWR0aCI6ODAwLCJoZWlnaHQiOjgwMH19XQ==",
    "ramen-3": "https://glovo.dhmedia.io/image/menus-glovo/products/91dd2706c4fa0e36c71274b957eac7f08c7c9b4e958d23a202e31519633d01a6?t=W3sicmVzaXplIjp7Im1vZGUiOiJmaXQiLCJ3aWR0aCI6ODAwLCJoZWlnaHQiOjgwMH19XQ==",
    "riso-24": "https://glovo.dhmedia.io/image/global-menu-service/GV_IT/vendor/773327/product/35795124309/97137e03-50b2-481a-b970-117d369f5b51.jpg?t=W3sicmVzaXplIjp7Im1vZGUiOiJmaXQiLCJ3aWR0aCI6ODAwLCJoZWlnaHQiOjgwMH19XQ==",
  };
  if (REAL[key]) return REAL[key];
  const list = CATEGORY_IMAGES[categoryId] || [];
  if (list.length === 0) return null;
  return list[index % list.length];
}

// Get allergens for an item — merge default + overrides
export function getItemAllergens(categoryId, itemN) {
  const key = `${categoryId}-${itemN}`;
  if (ITEM_ALLERGEN_OVERRIDES.hasOwnProperty(key)) {
    return ITEM_ALLERGEN_OVERRIDES[key];
  }
  return CATEGORY_ALLERGENS[categoryId] || [];
}
